(ns ui.view.card.survey-processes.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.card.sub :as common-sub]
   [ui.state.session.sub :as session-sub]
   [common.util :as cu]
   [ui.view.card.entity-list.util :as entity-list-util]))

(defn create-process-button-state
  [{:keys [preview-mode? read-only-user? survey-profile]}]
  (let [contact-selected? (number? (:survey-profile/their-contact survey-profile))]
    {:visible? (not read-only-user?)
     :disabled? (or preview-mode?
                    (not contact-selected?))
     :missing-contact? (not contact-selected?)}))

(rf/reg-sub
 ::survey-processes
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities-by-id]]
   (->> entities-by-id
        vals
        (cu/filter-by :entity/type :entity.type/survey-process)
        (sort-by :common/created-on)
        reverse
        vec)))

(rf/reg-sub
 ::survey-process-count
 (fn [[_ ctx]]
   [(rf/subscribe [::survey-processes ctx])])
 (fn [[processes]]
   (count processes)))

(rf/reg-sub
 ::table-data
 (fn [[_ ctx]]
   [(rf/subscribe [::survey-processes ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/entities])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[survey-processes
       card-entities-by-id
       global-entities-by-id
       tenant
       tenant-schema]
      [_ {:keys [card] :as _ctx}]]
   (let [all-entities-by-id (merge global-entities-by-id card-entities-by-id)
         column-fields (->> card
                            :card/config
                            :table
                            :columns
                            (mapv :field))]
     (entity-list-util/entities->table-row-data
      {:entities survey-processes
       :column-fields column-fields
       :entities-by-id all-entities-by-id
       :tenant tenant
       :tenant-schema tenant-schema}))))
